export const galleryImages = {
  todos: [
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/1b3f2bee-4ce7-4d47-3dde-5b19fa066d00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/b9361911-d3d6-4c92-0e75-04667c70e300/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/63788c41-d490-432a-471c-5e28b52bce00/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/2d4938a6-6347-4c70-6431-f5ef464fb800/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/655ba3d7-3387-4364-915c-064090bb3700/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/0a7bf05e-4665-4538-4213-bb1f35ec7100/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/574af829-6517-4754-b118-c48940585800/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/d3647739-a971-4494-5dbf-4f53bf55e400/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6bfa310d-afbd-4cfd-6963-bdd836f6ac00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/1afd63e9-efd4-40a5-9ff0-8713e0e17000/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f63f9432-1af4-4ecd-798e-40e84df71400/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/9382f6b9-8a8a-47de-fcc7-05fe69f8b200/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/d38289f2-4b92-4725-80f4-b6eb30052700/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f4dd1383-6520-4923-35a0-4b4d02143300/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/73a75f5a-8197-46e9-dc72-fbd93e676d00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6f4dd17b-39b4-4479-665e-61d7ce921700/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/774de42d-e3f2-410d-f61d-274792b46200/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/33798926-8d5a-4878-dbf3-908743836000/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/72b8b313-640d-445f-6a5b-74362019bc00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/8d5d683d-b864-477d-9a56-1a39af90c800/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/4987065b-7972-4c00-b9ff-a259cb9caf00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/5ee8a078-4bb8-4fc5-d11a-203be7c1ad00/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/11a81113-34af-4579-ae8e-3c92b29fc100/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/02004812-c834-42f2-a90e-1526da54a000/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/bebe2fa1-b52d-4cf9-ccd4-cf0aa7e99800/public'
  ],
  ramos: [
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/1b3f2bee-4ce7-4d47-3dde-5b19fa066d00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/b9361911-d3d6-4c92-0e75-04667c70e300/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6f4dd17b-39b4-4479-665e-61d7ce921700/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/774de42d-e3f2-410d-f61d-274792b46200/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/33798926-8d5a-4878-dbf3-908743836000/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/72b8b313-640d-445f-6a5b-74362019bc00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/8d5d683d-b864-477d-9a56-1a39af90c800/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/4987065b-7972-4c00-b9ff-a259cb9caf00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/5ee8a078-4bb8-4fc5-d11a-203be7c1ad00/publicContain'
  ],
  arreglos: [
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/0a7bf05e-4665-4538-4213-bb1f35ec7100/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/11a81113-34af-4579-ae8e-3c92b29fc100/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6d7efd33-630b-4275-b15a-197b143cf800/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/531a6878-3bc5-4312-2b02-0e9e10884f00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/1f9af76e-a665-4270-2c90-d5158b191900/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/88fe36c5-bf2e-4b91-52b4-2d886459cb00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/b90d6a47-8bc3-42a4-f1cb-eb831c018200/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/2e9f36fa-8465-4b20-00d8-0122d0be1700/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/dafd703d-7030-43d9-87dc-5f18a2aaf200/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/e0b28f8a-622d-42f0-9742-ec3e33330000/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/52889a29-4e24-4972-bc10-ee498754a400/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/822eee43-8bdb-47db-13b2-6b66b0332900/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/e61b2651-ef90-45ef-f9cd-4308fc192400/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c7e97dc7-f32c-49b9-64c8-8eb1a2bd2900/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/e973e1ac-d874-49ca-fdbb-0e546ca62e00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/bb84f22d-c8a0-40d1-0b26-83458e4f6a00/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/64e4257c-b6f0-438a-1b4e-1a3b5b00c600/public'
  ],
  boxes: [
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/63788c41-d490-432a-471c-5e28b52bce00/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/574af829-6517-4754-b118-c48940585800/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/73a75f5a-8197-46e9-dc72-fbd93e676d00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/23ea6340-dcae-49ab-95d7-8378f0445400/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/426a28a9-4e6d-4995-22eb-cfa2dc3b7800/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/4142a4a8-88ef-4a63-1b16-504cf43b4d00/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6cf6eeb8-6deb-4559-962d-3b68662af000/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/b8b1a881-56a1-46b8-39a0-f8b9b1c0d500/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c0318901-a2e6-4ddd-bb67-6579c1e2f900/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f3e52192-1e7e-475c-14fe-4d85e87a9e00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/fcaf0a87-f320-424a-d307-371c73089f00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f63f9432-1af4-4ecd-798e-40e84df71400/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/1afd63e9-efd4-40a5-9ff0-8713e0e17000/publicContain'
  ],
  peluches: [
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/c4231067-2088-4e05-9bb4-95b94866a900/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/71dd0f3e-e4c9-4b3c-f2af-cf3fa2fd6e00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/94e28a04-8d92-4725-1682-77028fdc3300/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/8c08ee7e-af7c-4e35-a103-9a731bb17c00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/b5f1fb61-3b9a-4c43-6334-fa5bc13df300/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/b5dba90d-fac4-43ff-eae7-558553dc9900/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/d9af9e42-dc43-4e6f-73f5-e7d690ce3a00/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/22a0d5cc-e31f-4ea3-6ce7-6542b85e4000/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f45d2310-69c8-4eeb-a815-91531d28a000/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/12f52705-c214-41be-12c5-d4258d4dfb00/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/cb432b6e-cd58-4608-e267-83db3dceb100/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/ed4293ee-64a6-47ba-f96f-960745ced200/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/eb2fa98d-f3b7-4584-2afb-0af8911b0a00/public'
  ],
  eventos: [
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/2d4938a6-6347-4c70-6431-f5ef464fb800/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/9cf758b5-1b09-4aa3-8509-8409265eb800/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/8677e45a-1fa6-4768-9b4f-f01072370800/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/9afb6326-12e4-4843-8acb-0840eeacc300/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7ff96436-63de-4e74-a6ce-668caae43800/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/55d3b814-5964-482e-9e27-ad663a577a00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/2e6602b1-3e81-4a63-4e3f-de4c79aafb00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/87cbe215-919d-4a43-8a9b-9f341d11a800/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/779ae51e-df75-42a3-8362-61f7098c2100/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/17b2e34b-ff45-4532-d061-9be12efbf900/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/99dbcbae-43ff-4a97-55f1-2a81ac157300/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/d0c53585-900a-403c-6f3d-4d706a1fab00/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6918f478-3dd4-43d5-a7c1-a737cb2a7f00/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/8aa0d469-2824-4093-f701-330ad2d01800/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/385ba6a5-644c-422b-f0ed-5cd14c953100/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f60a1a56-41c7-4f85-6661-58f470f93b00/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f92c9966-be68-495c-e82c-0e90162b2000/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/ddb14acb-c74b-41c6-5ae0-93f23a9e7400/publicContain'
  ],
  detalles: [
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/655ba3d7-3387-4364-915c-064090bb3700/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/d3647739-a971-4494-5dbf-4f53bf55e400/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/02004812-c834-42f2-a90e-1526da54a000/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/0f3e73fe-8ecb-488d-f513-74d596806100/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/186e31c3-5847-472f-9d7c-34275fc25e00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6396d980-295f-4f8a-7b19-af59488bd300/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/e089d985-3b64-428a-175e-74e2a1794f00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/867e5979-cb6d-4790-ef23-e2981a48ea00/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f5493dce-7627-4eb8-0022-3c90a4fff100/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/ac3ca9e6-1d50-488a-605d-ca3d82638e00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/da1c43b4-1164-4868-7521-3a8a8bc10b00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/04dc2f81-3703-456d-37de-d49d48718f00/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/084a62fe-1db1-4c7d-2f85-9596353f0d00/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/44668b99-4736-44e7-2e61-44fb9fdae900/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/ef4ca53f-8df2-4f92-2804-803546585200/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/218690cf-9577-4d5f-15c1-79545919e500/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/8da1b809-1bf9-47cc-716f-7a5375700d00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6bfa310d-afbd-4cfd-6963-bdd836f6ac00/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/9382f6b9-8a8a-47de-fcc7-05fe69f8b200/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/d38289f2-4b92-4725-80f4-b6eb30052700/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f4dd1383-6520-4923-35a0-4b4d02143300/public',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/6c720026-0d79-4ceb-ebb2-b7b6aff28400/publicContain',
    'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/bebe2fa1-b52d-4cf9-ccd4-cf0aa7e99800/public'
  ]
};

export const galleryVideos = [
  {
    id: 1,
    thumbnail: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/7fbc6c7e-73d2-44aa-b8d8-ce88eaf11700/publicContain',
    url: 'https://www.instagram.com/p/C8BZj0ruoN1/',
    title: 'Ver Video'
  },
  {
    id: 2,
    thumbnail: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/310a4ed3-7a02-4ec4-3727-3724b027b000/public',
    url: 'https://www.instagram.com/p/DTtC904gUyV/',
    title: 'Ver Video'
  },
  {
    id: 3,
    thumbnail: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/5e23a773-2a69-49a5-53c7-952688315600/publicContain',
    url: 'https://www.instagram.com/p/DO2XWVOjHAi/',
    title: 'Ver Video'
  }
];

export const contactVideos = [
  {
    id: 1,
    thumbnail: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/63d0a1b3-6d56-4d22-3556-7bb3d41e7900/publicContain',
    url: 'https://www.instagram.com/p/CaU_-XqpYhT/',
    title: 'Ver Video'
  },
  {
    id: 2,
    thumbnail: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/f93e8221-2614-4ac6-108e-67707c14c900/publicContain',
    url: 'https://www.tiktok.com/@tqmfloreria/video/7597905840015805717',
    title: 'Ver Video'
  },
  {
    id: 3,
    thumbnail: 'https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/61b982c6-f6e5-4426-8ad8-35877585a500/public',
    url: 'https://www.tiktok.com/@tqmfloreria/video/7594268981763067156',
    title: 'Ver Video'
  }
];
